import {ISculptWizardState} from "../../../types/ui/wizard/sculpt";
import {defaultSculptConfig} from "../../../../peregrine/processor";
import {SculptWizardScreen} from "../../../types/types";

export const initialSculptState: ISculptWizardState = {
  config: defaultSculptConfig,
  subScreen: SculptWizardScreen.Sculpt
};
